// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredCategoriesStyles } from "@steiner/App/Widgets/FeaturedCategories/FeaturedCategories";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

featuredCategoriesStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        align-items: center;
    `,
};

featuredCategoriesStyles.title = {
    variant: "h2",
    css: css`
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 8px;
        width: 100%;
    `,
};

featuredCategoriesStyles.categoriesWrapper = {
    css: css`
        display: grid;
        justify-items: stretch;
        row-gap: 48px;
        column-gap: 22px;
        grid-template-columns: repeat(6, 1fr);

        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(4, 1fr);
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(3, 1fr);
            column-gap: 20px;
            row-gap: 24px;
        }

        ${xScreen("lte", "xs")} {
            grid-template-columns: repeat(2, 1fr);
            column-gap: 16px;
        }

        ${xScreen("lt", 360)} {
            grid-template-columns: repeat(1, 1fr);
        }
    `,
};
